import React from "react";

import { TaxType } from "@lib/shared-types";

import DetailsWrapper from "@components/DisplayDetails/DetailsWrapper";
import InvoiceDetails from "@components/DisplayDetails/InvoiceDetails";
import SmileIcon from "@components/Icons/SmileIcon";

interface PaymentConfirmationBoxProps {
  invoice: any;
  taxType: TaxType;
}

export const PaymentConfirmationBox: React.FC<PaymentConfirmationBoxProps> = ({
  invoice,
  taxType,
}) => {
  return (
    <>
      <div className="rounded-xl bg-foreground/7 p-4">
        <div className="grid grid-cols-1 justify-items-center ">
          <SmileIcon className="text-accent w-8 h-8 mt-5" />
          <div className="text-foreground font-medium text-xl p-2">
            Thanks for your purchase!
          </div>
          <div className="text-foreground text-center">
            You&apos;ll receive a receipt via email shortly.
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h3 className="font-medium mb-1 text-foreground">Payment summary</h3>
        <DetailsWrapper>
          <InvoiceDetails
            invoice={invoice}
            taxType={taxType}
            hasPaid
            disableFold
          />
        </DetailsWrapper>
      </div>
    </>
  );
};
